(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-shared/map-assets.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-shared/map-assets.js');

'use strict';

var _svs$lyckoplatsen$dat, _svs$lyckoplatsen;
const lyckoplatsenConfig = (_svs$lyckoplatsen$dat = (_svs$lyckoplatsen = svs.lyckoplatsen) === null || _svs$lyckoplatsen === void 0 || (_svs$lyckoplatsen = _svs$lyckoplatsen.data) === null || _svs$lyckoplatsen === void 0 ? void 0 : _svs$lyckoplatsen.config) !== null && _svs$lyckoplatsen$dat !== void 0 ? _svs$lyckoplatsen$dat : {};
const tileLayerUrl = "".concat(lyckoplatsenConfig.mapLocation, "/tile/{z}/{x}/{y}.png?token=").concat(lyckoplatsenConfig.jwt);
const iconBasePath = "".concat(svs.core.config.data.svsconfig.cdn, "/images/tur/lyckoplatsen");
const pinPath = "M0.333374 26.764C0.333374 11.5017 11.8379 0 27 0V0.00415163C42.0584 0.00415163 53.6667 11.5059 \n53.6667 26.7681C53.6667 33.1188 51.2963 38.0362 48.2196 43.2673C45.143 48.4985 27 80 27 80C27 80 8.61371 \n47.9645 5.69745 43.1968C2.78119 38.429 0.333374 33.0855 0.333374 26.764ZM10.7487 22.9781C10.7487 18.5127 \n14.4089 14.9257 18.8743 14.9257C23.3398 14.9257 27 19.7938 27 19.7938C27 19.7938 30.6602 14.9257 35.1257 \n14.9257C39.6278 14.9257 43.2514 18.5493 43.2514 22.9781C43.2514 26.5652 41.8239 35.0934 27.8053 43.7316C27.5491 \n43.878 26.9635 44.244 26.9635 44.244C26.9635 44.244 26.3778 43.878 26.1216 43.7316C12.1761 35.0934 10.7487 \n26.5652 10.7487 22.9781Z";
const colorMap = {
  blue: '#2073E5',
  lp: '#2073E5',
  midBlue: '#1047B8',
  'lp-100': '#1047B8',
  darkBlue: '#001E3C',
  'lp-200': '#001E3C',
  green: '#16FFAB',
  'lp-300': '#16FFAB',
  red: '#FF5D39',
  'lp-400': '#FF5D39',
  lightBlue: '#DDECFF',
  'lp-500': '#DDECFF',
  lightGreen: '#D5FFF0',
  'lp-600': '#D5FFF0',
  white: '#FFFFFF',
  black: '#000000'
};
const isHexColor = str => /^#([0-9A-F]{3}){1,2}$/i.test(str);
const getColor = color => isHexColor(color) ? color : colorMap[color] || colorMap.lp;
const getFormattedPinLabel = _ref => {
  let {
    count,
    winAmount
  } = _ref;
  if (winAmount > 0 && !count) {
    if (winAmount >= 1000000) {
      const millions = Math.floor(winAmount / 1000000);
      return "<i>".concat(millions, " mkr</i>");
    } else if (winAmount > 1000) {
      const thousands = Math.floor(winAmount / 1000);
      return "<i>".concat(thousands, "  tkr</i>");
    }
    return "<i>".concat(winAmount, " kr</i>");
  }
  if (count > 0) {
    return "<i>".concat(count, "</i>");
  }
  return '';
};
const get3dPinIcon = _ref2 => {
  let {
    winAmount,
    count,
    color = 'green',
    useDefaultIconSizes = true,
    useSmallIcon = false,
    pyro = false,
    className = ''
  } = _ref2;
  const isHighestTopWin = winAmount >= 1000000;
  let iconUrl = "".concat(iconBasePath, "/pin3dgreen.png");
  if (color === 'red') {
    iconUrl = "".concat(iconBasePath, "/pin3dred.png");
  }
  const pyroHtml = "<div class=\"pyro".concat(pyro ? ' pyro-active' : '', "\"><div class=\"before\"></div><div class=\"after\"></div></div>");
  const amountHtml = getFormattedPinLabel({
    count,
    winAmount
  });
  let height = 144;
  let width = 120;
  if (useDefaultIconSizes) {
    if (useSmallIcon) {
      height = 80;
      width = 66;
    } else if (svs.core.detect.breakpoint.current === 'xs' || svs.core.detect.formfactor.mobile()) {
      height = 96;
      width = 80;
    }
  }
  const iconHtml = "<div class=\"pin-image\" style=\"background-image: url('".concat(iconUrl, "'); background-size: contain;\n    background-repeat: no-repeat; background-position: center; width: ").concat(width, "px; height: ").concat(height, "px;\">\n    <div class=\"wrapper\">").concat(amountHtml).concat(pyroHtml, "</div>\n    </div>");
  const extraClasses = [className];
  if (isHighestTopWin) {
    extraClasses.push('top-win-marker');
  }
  if (useSmallIcon) {
    extraClasses.push('icon-small');
  }
  if (count) {
    extraClasses.push('count');
  }
  return leaflet.divIcon({
    html: iconHtml,
    iconSize: [width, height],
    iconAnchor: [width / 2, height * 0.73],
    className: "pin-heart text-marker lp-3dpin lp-3dpin-".concat(color, " ").concat(extraClasses.join(' '))
  });
};
Object.assign(svs.tur.lyckoplatsen.map, {
  tileLayerUrl,
  pinPath,
  getColor,
  get3dPinIcon
});

 })(window);